const handleArtistsDisplay = (artists = []) => {
  const artistsName = artists.map(artist => {
    return artist.name
  })

  return artistsName.join(' - ')
}

export default handleArtistsDisplay
